
document.addEventListener('DOMContentLoaded', function () {
    function show_hide_color () {
        $('.product-color-swatch-wrapper .swatch').removeClass('hidden');
        $('.variant_list .variant_item .item:not(.active)').each(function () {
            const htmlContent = $(this).attr('data');
            $(this).parents('.variant_list').find(`.swatch[data*='${htmlContent}']`).addClass('hidden');
        });
    }
    show_hide_color();
    $('.product-color-swatch-wrapper .swatch').click(function () {
        $(this).addClass('active').siblings().removeClass('active');
        let variant_id = $(this).data('id');
        console.log(1111, 'variant_id', variant_id)
        let variant_sku = $(this).data('sku');
        let available = $(this).data('varavailable');
        $(this)
            .parents('.buy-card')
            .find('.price_list')
            .find(`.price[data-id=${variant_id}]`)
            .addClass('active')
            .siblings()
            .removeClass('active');

        console.log(111, `.variant-image[data-id='${variant_id}']`, $(this)
            .parents('.buy-card').find(`.variant-image[data-id='${variant_id}']`))
        $(this)
            .parents('.buy-card')
            .find(`.variant-image[data-id='${variant_id}']`)
            .removeClass('hidden')
            .addClass('active')
            .siblings()
            .addClass('hidden')
            .removeClass('active');
        $(this).parents('.buy-card').find('add-cart-button').attr('data-variant-id', variant_id);
        if (available) {
            $(this).parents('.buy-card').find('add-cart-button').removeClass('disabled');
            $(this).parents('.buy-card').find('add-cart-button').text('ADD TO CART');
        } else {
            $(this).parents('.buy-card').find('add-cart-button').addClass('disabled');
            $(this).parents('.buy-card').find('add-cart-button').text('SOLD OUT');
        }
        $(this).parents('.buy-card').find('.product_info').attr('data-sku', variant_sku);


    });


    $('.buy-card .product-info-wrapper').off('click').on('click', function () {
        $(this).toggleClass('active')
        $(this).find('.product_select').slideToggle()
    })


    $('.product_info.opencomm2uc-2025-upgrade .variant_list .variant_values .item:first-child').click();
    $('.product_info.openfit2plus .variant_list .variant_values .item:first-child').click();
    $(".product-color-swatch-wrapper .swatch[data-id='44043747819720']").click()
    $(".product-color-swatch-wrapper .swatch[data-id='44865963720904']").click()
    $(".product-color-swatch-wrapper .swatch[data-id='44747344675016']").click()
});

